
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { CardHeader, CardTitle } from '@/components/ui/card';

interface AddProfileHeaderProps {
  onBack: () => void;
}

const AddProfileHeader = ({ onBack }: AddProfileHeaderProps) => {
  return (
    <CardHeader className="border-b border-gray-100 dark:border-gray-700 flex items-center">
      <Button variant="ghost" size="icon" onClick={onBack} className="mr-2">
        <ArrowLeft className="h-4 w-4" />
      </Button>
      <CardTitle className="text-lg font-medium text-custom-dark dark:text-gray-100">Ajouter de nouveaux profils & comptes de publicité</CardTitle>
    </CardHeader>
  );
};

export default AddProfileHeader;
